import React, {useState, useEffect} from 'react';
import clsx from 'clsx';
import {connect} from 'react-redux'
import * as actions from '../../store/actions'
import validate from 'validate.js';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Button
} from '@mui/material';

import withErrorHandler from '../../hocs/withErrorHandler'
import axios from '../../httpClients/axios-datamerch'

import FeedbackInfo from './FeedbackInfo'
import useClasses from '../../helpers/useClasses';


const styles = theme => ({
  root: {}
});

const FeedbackDialog = React.memo(props => {
  const { className, open, onCloseFeedbackDialog, onFeedbackSubmit } = props;

  let schema = {};
  
  const classes = useClasses(styles);

  const [formState, setFormState] = useState({
    isValid: false,
    values: {},
    touched: {},
    errors: {}
  });

  useEffect(() => {
    const errors = validate(formState.values, schema);

    setFormState(formState => ({
      ...formState,
      isValid: errors ? false : true,
      errors: errors || {}
    }));
  }, [formState.values]);

  useEffect(() => {
    setFormState(formState => ({
      ...formState,
      isValid: false,
      errors: {},
      values: {
        reason: ''
      }
    }));
  }, [open])

  const hasError = field =>
    formState.touched[field] && formState.errors[field] ? true : false;

  const handleChange = event => {
    event.persist();

    setFormState(formState => ({
      ...formState,
      values: {
        ...formState.values,
        [event.target.name]:
          event.target.type === 'checkbox'
            ? event.target.checked
            : event.target.value
      },
      touched: {
        ...formState.touched,
        [event.target.name]: true
      }
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    let name = event.target.name.value;
    let email = event.target.email.value;
    let feedbacktype = event.target.feedbacktype.value;
    let subject = event.target.subject.value;
    let description = event.target.description.value;
    
    const data = {
        name: name,
        email: email,
        feedbacktype: feedbacktype,
        subject: subject,
        description: description
    };

    if(formState.isValid)
        onFeedbackSubmit(data)
  }

  const handleDialogClose = () => {
    onCloseFeedbackDialog()
    // onInializeAddMerchant()
  };

  return (
    <Dialog
      className={clsx(classes.root, className)}
      open={open}
      onClose={handleDialogClose}
      maxWidth={'md'}
      fullWidth
    >
      <DialogTitle id="form-dialog-title">Feedback, Questions, and Support Requests</DialogTitle>
      <Divider />
      <form
        autoComplete="off"
        onSubmit={handleSubmit}
      >
        <DialogContent>
          <FeedbackInfo
            onChange={(event) => handleChange(event)}
            formState={formState}
            hasError={(field) => hasError(field)}
          />
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button
            color="primary"
            variant="contained"
            type="submit"
          >
            Submit Feedback
          </Button>
          <Button
            color="secondary"
            onClick={(event) => handleDialogClose(event)}
          >
            Cancel
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
});


const mapStateToProps = state => {
    return {
      open: state.feedback.feedback_dialog_open,
      // dialog_id: state.merchant.dialog_id
    }
  }
  
  const mapDispatchToProps = dispatch => {
    return {
      onCloseFeedbackDialog: () => dispatch(actions.closeFeedbackDialog()),
      onOpenFeedbackDialog: () => dispatch(actions.openFeedbackDialog()),
      onFeedbackSubmit: (data) => dispatch(actions.addFeedback(data))
    }
  }
  
  export default connect(mapStateToProps, mapDispatchToProps)(FeedbackDialog)